import { defineStore } from 'pinia'
import { addDays } from 'date-fns'
import { getLeadByUuid } from '@/api/lead'
import { viewLeadPage } from '@/api/user'

export const useProcessingLeadStore = defineStore('processingLead', {
  state: () => {
    return {
      processingLead: {
        uuid: '',
        firstName: '',
        lastName: '',
        step: 0,
        integrationMonth: new Date(),
        meetRequestDate: new Date(),
        status: '',
        substatus: '',
        comment: '',
        market: {
          mission: {
            bannerUrl: '',
            color: '',
            leadProcessingDurationDays: 60,
          },
        },
      },
      initialized: false,
    }
  },
  actions: {
    async fetchLead(uuid) {
      this.initialized = false
      this.processingLead = await getLeadByUuid(uuid)
      this.initialized = true

      viewLeadPage({ leadId: this.processingLead.id })
    },
  },
  getters: {
    lead: (state) => {
      return {
        ...state.processingLead,
        expirationDate: addDays(new Date(state.processingLead.meetRequestDate), state.processingLead.market.mission.leadProcessingDurationDays),
      }
    },
    mission: (state) => state.processingLead?.market?.mission,
    isInitialized: (state) => !!state.initialized,
    callProcess: (state) => state.processingLead?.market?.mission?.callProcess,
    currentStep: (state) =>
      state.callProcess?.callProcessSteps.find(
        (step) => state.processingLead.step === step.number,
      ) || {},
    callProcessMaxStep: (state) =>
      Math.max(...(state?.callProcess?.callProcessSteps.map((step) => step.number) || []), 0),
    isWaitingForForcedAppointment: (state) => state.processingLead.substatus === 'WAITING_FOR_FORCED_RDV',
    appointment: (state) => state.processingLead.metadata?.appointment,
  },
})
